import { render } from "./Insurance.vue?vue&type=template&id=14b79d7f&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"

import "./Insurance.vue?vue&type=style&index=0&id=14b79d7f&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b79d7f"]])

export default __exports__